const animateValue = (id, start, end, duration) => {
    let obj = document.getElementById(id);
    let range = end - start;
    let minTimer = 50;
    let stepTime = Math.abs(Math.floor(duration / range));
  
    stepTime = Math.max(stepTime, minTimer);
  
    let startTime = new Date().getTime();
    let endTime = startTime + duration;
    let timer;
  
    const run = () => {
      var now = new Date().getTime();
      var remaining = Math.max((endTime - now) / duration, 0);
      var value = Math.round(end - (remaining * range));
  
      obj.innerHTML = value;
  
      if (value === end) {
        clearInterval(timer);
      }
    }
  
    timer = setInterval(run, stepTime);
    run();
  }
  
  export default animateValue;


// WEBPACK FOOTER //
// ./src/helpers/animateValue.js